import { Module } from 'vuex'
import { mutations } from './mutations'
import { RegisterState } from './types'
import { RootState } from '@/types'

export const state: RegisterState = {
  step: -1,
  stepMax: 2,
}

const namespaced: boolean = true

export const register: Module<RegisterState, RootState> = {
  namespaced,
  state,
  mutations
}
